module.exports = __webpack_public_path__ + "assets/img/kv-e4a20a20.jpg";